import { Input } from 'components/input';
import style from './styles.module.scss';
import InputSQMeter from 'components/input-sq-meter';
import Button from 'components/button';
import { SQ_METER_SIGN } from 'lib/constants';
import NumberInput from 'components/number-input';
import { IDataRansom } from '../../modals/modalAnalogs/outOfSystem/modalRansom';
import { IDataSupport } from '../../modals/modalAnalogs/outOfSystem/modalSupportDeal';

type IDataFormRequest = Partial<IDataRansom & IDataSupport>;

interface IFormRequestProps {
  text: string;
  data: IDataFormRequest;
  titleForPatForm?: string;
  buttonLabel: string;
  onClick: () => void;
  onChange?: (value: string, key: string) => void;
  onBlurInput?: () => void;
  onFocusInput?: () => void;
  type: 'by' | 'sell' | 'default';
  isSkipOptionsSellTradeIn?: boolean;
  labelForApartment?: string;
  isLoading: boolean;
}

const FormRequest = ({
  text,
  data,
  buttonLabel,
  titleForPatForm,
  type,
  labelForApartment,
  isLoading,
  isSkipOptionsSellTradeIn = false,
  onClick,
  onChange,
  onBlurInput,
  onFocusInput,
}: IFormRequestProps) => {
  let disabled = false;

  if ('userApartmentNumber' in data) {
    disabled = !Boolean(data.userApartmentNumber) || disabled;
  }

  if ('userApartmentAreaInSqM' in data && !isSkipOptionsSellTradeIn) {
    disabled = !Boolean(data.userApartmentAreaInSqM) || disabled;
  }

  if ('userAddress' in data && !isSkipOptionsSellTradeIn) {
    disabled = !Boolean(data.userAddress) || disabled;
  }

  const handleFocus = () => {
    onFocusInput && onFocusInput();
  };

  const handleBlur = () => {
    onBlurInput && onBlurInput();
  };

  return (
    <div className={style.formRequest}>
      <div className={style.formRequest__container}>
        <div className={style.formRequest__text}>
          <p>{text}</p>
        </div>

        <form className={style.formRequest__form} onSubmit={(e) => e.preventDefault()}>
          {type === 'by' && (
            <div>
              <h4>{titleForPatForm}</h4>
            </div>
          )}
          {type === 'by' && 'userAddress' in data && (
            <div className={style.formRequest__address} id='scroll-address'>
              <Input
                label='Полный адрес'
                placeholder='Например: Мира 15'
                value={data.userAddress as string}
                onChange={(value) => onChange && onChange(value, 'userAddress')}
                isMainPlaceholder
                onBlur={handleBlur}
                onFocus={handleFocus}
              />
            </div>
          )}
          {type === 'by' && 'userApartmentAreaInSqM' in data && (
            <div className={style.formRequest__square} id='scroll-apartment-area-in-sqM'>
              <InputSQMeter
                value={data.userApartmentAreaInSqM as string}
                onChange={(value) => onChange && onChange(value, 'userApartmentAreaInSqM')}
                placeholder={`Например: 22.2 ${SQ_METER_SIGN}`}
                onBlurInput={handleBlur}
                onFocusInput={handleFocus}
              />
            </div>
          )}
          {type === 'by' && (
            <div className={style.formRequest__apartmentNumber} id='user-apartment-number-by'>
              <NumberInput
                mode='apartment'
                label='Номер квартиры'
                value={data.userApartmentNumber ?? ''}
                placeholder='Например: 15'
                isMainPlaceholder
                onChange={(value) => {
                  if (value.length < 6) {
                    onChange && onChange(value, 'userApartmentNumber');
                  }
                }}
                type='number'
                onBlur={handleBlur}
                onFocus={handleFocus}
              />
            </div>
          )}

          <div>
            <h4>{labelForApartment}</h4>
          </div>
          <div className={style.formRequest__address}>
            <Input value={data.address} label='Адрес квартиры' readOnly />
          </div>
          {data.apartmentType && (
            <div className={style.formRequest__apartmentType}>
              <Input value={data.apartmentType} label='Тип квартиры' readOnly />
            </div>
          )}
          <div className={style.formRequest__areaInSqM}>
            <InputSQMeter value={data.areaInSqM + ' ' + SQ_METER_SIGN} readOnly />
          </div>

          {type === 'sell' && (
            <div className={style.formRequest__apartmentNumber} id='user-apartment-number-sell'>
              <NumberInput
                mode='apartment'
                label='Номер квартиры'
                value={data.userApartmentNumber ?? ''}
                placeholder='Например: 15'
                isMainPlaceholder
                type='number'
                onChange={(value) => {
                  if (value.length < 6) {
                    onChange && onChange(value, 'userApartmentNumber');
                  }
                }}
                onBlur={handleBlur}
                onFocus={handleFocus}
              />
            </div>
          )}
        </form>

        <div className={style.formRequest__button}>
          <Button label={buttonLabel} onClick={onClick} disabled={disabled} loading={isLoading} />
        </div>
      </div>
    </div>
  );
};

export default FormRequest;
